<button
	(click)="openAddLaneForm()"
	*ngIf="!editLane"
	[disabled]="isDisabled"
	class="invited-chip"
	mat-raised-button
>
	Add Lane
</button>
<mat-icon
	(click)="openAddLaneForm()"
	*ngIf="editLane"
	style="color: cornflowerblue; cursor: pointer"
	>edit</mat-icon
>
